<template>
    <div class="fixed inset-0 overflow-y-auto z-10">
        <div class="flex items-center justify-center min-h-screen">
            <transition appear=""
                enter-active-class="ease-out duration-300"
                enter-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="ease-in duration-200"
                leave-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                    <div class="absolute inset-0 bg-gray-darker opacity-75"></div>
                </div>
            </transition>
            
            <!-- Main contents of the modal -->
            <transition appear=""
                enter-active-class="transition ease-out duration-100 transform"
                enter-class="opacity-0 translate-y-4 scale-95"
                enter-to-class="opacity-100 translate-y-0 scale-100"
                leave-active-class="transition ease-in duration-75 transform"
                leave-class="opacity-100 translate-y-0 scale-100"
                leave-to-class="opacity-0 translate-y-4 scale-95"
            >
                <div class="relative w-full bg-white shadow-lg rounded-lg p-2 m-2" :class="sizeClass">
                    <header class="flex justify-between items-center text-xl font-bold p-4 border-b border-gray-dark">
                        <slot name="header"></slot>
                        <button aria-label="close" class="" @click.prevent="close">×</button>
                    </header>
                    <main class="p-4">
                        <slot></slot>
                    </main>
                    <footer class="p-4">
                        <slot name="footer"></slot>
                    </footer>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            required: false,
        }
    },
    computed: {
        sizeClass() {
            if (this.size === '2x') return 'max-w-2xl';
            
            if (this.size === '3x') return 'max-w-3xl';

            return 'max-w-xl';
        }
    },
    mounted() {
        document.querySelector('body').classList.add('overflow-hidden');
    },
    destroyed() {
        document.querySelector('body').classList.remove('overflow-hidden');
    },
    methods: {
        close() {
            this.$emit('close');
        },
    }
}
</script>